import React from "react";
import { Layout } from "components/ui/Layout";
import { Page, PageTitle } from "components/ui/Page";
import { UIDErrorCard } from "components/cards/UIDErrorCard";

export function UIDErrorPage() {
  return (
    <Layout>
      <Page>
        <PageTitle title="Unrecognized Log-in" />
        <UIDErrorCard />
      </Page>
    </Layout>
  );
}
